// extracted by mini-css-extract-plugin
export default {"iag":"Settings_iag__jp24N","iac":"Settings_iac__wGuq3"};